import { MARQUEE_ITEMS } from '../data/site';

/**
 * Decorative ticker. Presentational only, so it is hidden from assistive
 * technology, and the animation stops entirely under reduced motion.
 */
export function Marquee() {
  const track = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];

  return (
    <div
      aria-hidden="true"
      className="relative flex overflow-hidden border-y border-line bg-surface py-3 backdrop-blur-md select-none"
    >
      <span className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-[linear-gradient(90deg,var(--bg),transparent)]" />
      <span className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-[linear-gradient(270deg,var(--bg),transparent)]" />

      <ul className="animate-marquee flex w-max shrink-0 items-center gap-9 pr-9 will-change-transform motion-reduce:animate-none">
        {track.map((item, i) => (
          <li key={`${item}-${i}`} className="eyebrow flex items-center gap-9 whitespace-nowrap">
            <span className={i % MARQUEE_ITEMS.length === 0 ? 'text-accent-2' : 'text-muted'}>
              {item}
            </span>
            <span className="text-accent" aria-hidden="true">
              ◆
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
